import React from 'react';
import { sliceTextAddEllipsis } from '#shared/utils/sliceTextAddEllipsis';
import { DEFAULT_MAX_TEXT_LENGTH } from '#shared/constants/common';
import styled from 'styled-components';

const StyledComponentCustomCurrent = styled.div`
  flex: none;
  order: 0;
  flex-grow: 0;
  color: #32324d;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

const CurrentCrumb = ({ label }) => {
  return (
    <div>
      <StyledComponentCustomCurrent>
        {sliceTextAddEllipsis(label, DEFAULT_MAX_TEXT_LENGTH)}
      </StyledComponentCustomCurrent>
    </div>
  );
};

export default CurrentCrumb;
